import { connect } from 'react-redux';
import { Instances, SideBarTypes } from '../../../constants';
import { requestLogout, requestLogin } from '../../../store/login';

import { IStateType } from '../../../store/models/root.interface';
import { openSideBar } from '../../../store/sidebar';
import UserProfile, {
	MapStateType,
	DispatchPropsType,
} from '../organisms/UserProfileMenu';
import { requestObject } from '../../../store/Object';


const mapStateToProps = (state: IStateType) => ({
	profile: state.profile.fullProfile,
});

const mapDispatchToProps = {
	onLogOut: () => requestLogout(),
	profileSetting: () => openSideBar(SideBarTypes.profileSetting),
	requestLogin: () => requestLogin(),
	parentLogout: ( callBack: any) =>
		requestObject(
			Instances.ParentLogoutAsSubaccount,
			undefined,
			undefined,
			'POST',
			true,
			true,
			undefined,
			callBack
		),
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(UserProfile);
